import { ADMIN, CURATOR, CUSTOMER, DEVELOPER, QUALITY_ASSURANCE } from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useTiersPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole()

  return {
    canCreate: false,
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE, CURATOR),
    canDelete: false,
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER)
  }
}
